import { Pipe, PipeTransform } from '@angular/core';
import { LoginService } from '../../../../../../services/login/login.service';

@Pipe({
  name: 'almacenPre'
})
export class SucursalPredeterminadaPipe implements PipeTransform {
  constructor(private login: LoginService) { }

  transform(data: string): string {
    const dataUser = this.login.getDataClientePedido();
    if (dataUser.sucursal === 'KABIK NORTE' || dataUser.sucursal === 'Kabik Norte') {
      return 'Tampico';
    }
    return data + '' + dataUser.sucursal;
  }
}
